import { render } from "./TextLink.vue?vue&type=template&id=40eb941d&scoped=true&ts=true"
import script from "./TextLink.vue?vue&type=script&lang=ts"
export * from "./TextLink.vue?vue&type=script&lang=ts"

import "./TextLink.vue?vue&type=style&index=0&id=40eb941d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eb941d"]])

export default __exports__